/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据活动id,获取活动基本信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.ActivityInfoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/${id}/activity-base-info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
